@if (hasSideNav) {
  <su-slot-mobile-top-bar
    [brandingLogoXs]="brandingLogoXs"
    [brandingTitle]="brandingTitle"
    [navItemsTree]="(menuService.getFilteredMenu() | async) ?? []"
    [metaNavItemsTree]="(menuService.getMetaNav() | async) ?? []"
    [topBarBtns]="topBarBtns"
    [accountBtns]="accountBtns"
    [isOpen]="isSideNavOpen"
    [activeNavItem]="activeNavItem"
    (onToggle)="handleSideNavToggle()"
    (onLogoClick)="handleHomeBtnClick()"
  ></su-slot-mobile-top-bar>
}
@if (hasSideNav) {
  <su-slot-side-nav
    [brandingLogoXl]="brandingLogoXl"
    [brandingLogoXs]="brandingLogoXs"
    [brandingTitle]="brandingTitle"
    [isOpen]="isSideNavOpen"
    [activeNavItem]="activeNavItem"
    [navItemsTree]="(menuService.getFilteredMenu() | async) ?? []"
    [metaNavItemsTree]="(menuService.getMetaNav() | async) ?? []"
    (onToggle)="handleSideNavToggle()"
    (onLogoClick)="handleHomeBtnClick()"
  ></su-slot-side-nav>
}
<su-slot-main [hasSideNav]="hasSideNav" [isSideNavOpen]="isSideNavOpen">
  <su-slot-top-bar
    [breadcrumbs]="breadcrumbs"
    [topBarBtns]="topBarBtns"
    [accountBtns]="accountBtns"
    [userInfo]="(authService.getUserName() | async) ?? ''"
    (onHomeBtnClick)="handleHomeBtnClick()"
    (onBackBtnClick)="handleBackBtnClick()"
  ></su-slot-top-bar>
  <router-outlet></router-outlet>
</su-slot-main>
